import React from "react";
import { FaChevronDown } from "react-icons/fa";

export default function CollapseSection({ title, text, extra, open, onToggle, children }) {
  return (
    <section className={`te-collapse ${open ? "is-open" : ""}`}>
      <button type="button" className="te-collapse-toggle" aria-expanded={open} onClick={onToggle}>
        <span className="te-collapse-summary">
          <strong>{title}</strong>
          {text ? <small>{text}</small> : null}
        </span>
        {extra ? <span className="te-footer-link-count">{extra}</span> : null}
        <FaChevronDown size={11} className="te-footer-chevron" />
      </button>
      {open ? <div className="te-collapse-body">{children}</div> : null}
    </section>
  );
}
